module.exports = __webpack_public_path__ + "images/afbde36e6636993610a724ed9e20290e.png";